import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_CURRENCY, formatAmount } from '../../../utils/currency';

import styles from './index.module.scss';

const TotalCost = ({ values }) => {
  const donationAmount = +values.amount[values.donation_type];

  const totalAmount =
    values.fundraisingCostsApplied && values.donation_type === 'single'
      ? values.totalAmount
      : donationAmount;

  return (
    <div className={styles['total-cost']}>
      <div className={styles['total-cost__label']}>Total</div>
      <div className={styles['total_cost__value']}>
        {formatAmount(DEFAULT_CURRENCY, donationAmount > 0 ? totalAmount : 0)}
      </div>
    </div>
  );
};
TotalCost.propTypes = {
  values: PropTypes.object.isRequired,
};

export default TotalCost;
